import React, { forwardRef } from 'react';
import clsx from 'clsx';
import CloseOutlined from '@material-ui/icons/CloseOutlined';
import MuiIconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import useStyles from './styles';

export type DialogCloseProps = IconButtonProps;

const DialogClose: React.FC<DialogCloseProps> = forwardRef<HTMLButtonElement, DialogCloseProps>(function DialogClose(
    { className, ...rest },
    ref,
) {
    const classes = useStyles();
    const classNameMerged = clsx({ [classes.closeButton]: true }, className);

    return (
        <MuiIconButton ref={ref} className={classNameMerged} data-testid="button-close" size="small" {...rest}>
            <CloseOutlined />
        </MuiIconButton>
    );
});

export default DialogClose;
